import { render } from "./PermissionsByShop.vue?vue&type=template&id=5341f55d&scoped=true"
import script from "./PermissionsByShop.vue?vue&type=script&lang=ts"
export * from "./PermissionsByShop.vue?vue&type=script&lang=ts"

import "./PermissionsByShop.vue?vue&type=style&index=0&id=5341f55d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5341f55d"

export default script